import { render, staticRenderFns } from "./RecommendationByTopic.vue?vue&type=template&id=1de7f528&scoped=true&"
import script from "./RecommendationByTopic.vue?vue&type=script&lang=js&"
export * from "./RecommendationByTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de7f528",
  null
  
)

export default component.exports